// THIS FILE IS AUTO GENERATED
var GenIcon = require('../lib').GenIcon
module.exports.BiUserPin = function BiUserPin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24"},"child":[{"tag":"path","attr":{"d":"M12 10c1.151 0 2-.848 2-2s-.849-2-2-2c-1.15 0-2 .848-2 2S10.85 10 12 10zM12 11c-2.209 0-4 1.612-4 3.6v.386h8V14.6C16 12.612 14.209 11 12 11z"}},{"tag":"path","attr":{"d":"M19,2H5C3.897,2,3,2.897,3,4v13c0,1.103,0.897,2,2,2h4l3,3l3-3h4c1.103,0,2-0.897,2-2V4C21,2.897,20.103,2,19,2z M14,17 l-2,2l-2-2H5V4h14l0.002,13H14z"}}]})(props);
};
